// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hfog","right":"styles_right__295dc"};